<template>
  <transition name="bounceRight">

    <div id="notificationCenter" v-show="panelActive" v-on:load="load">
      <div class="notification_header">
        <div class="notification_banner flex_display">
        <div class="div_aline_left">
          <span class="notification_center_title"><font-awesome-icon :icon="['fas', 'bell']" class="notification_center_title_icon"></font-awesome-icon> Notifications</span>
        </div>
        <div class="div_aline_right notification_center_header_right">

          <div class="icons">
            <div class="icon-box">
              <svg v-on:click="tohide" class="icon-close scale" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><title>Close</title><polygon points="12 1.4 10.6 0 6 4.6 1.4 0 0 1.4 4.6 6 0 10.6 1.4 12 6 7.4 10.6 12 12 10.6 7.4 6 12 1.4"/></svg>
            </div>

          </div>
        </div>
      </div>
        <div class="notification_splash flex_display">
          <div class="div_aline_left splash_information_container">
            <div class="splash_information_date">
              System update - June 2018
            </div>
            <div class="splash_information_wutsnew">
              What's new in Neon?
            </div>
          </div>
          <div class="div_aline_right flex_display splash_information_wutsnew_container">
            <button class="neon_btn neon_btn_default flex_display_centered_child" @click="showSplash">
              See the updates
            </button>
            <modal name="splash"
                   :width="1100"
                   :height="800"
                   :classes="['splash_modal', 'v--modal']">
              <div style="width: 100%;;">
                <div class="flex_display">
                  <h3 class="flex_display_centered_child"> You got a message from future </h3>
                </div>
                <div class="flex_display">
                  <img class="flex_display_centered_child" src="../assets/image/future.png">
                </div>
              </div>
            </modal>
          </div>
          <div></div>
        </div>
        <div id="notification_filter" class="flex_display">
          <div class="div_aline_left notification_unread_message_container">
            <div class="notification_unread_message">
              {{unreadNumber}} unread notifications
            </div>
            <div class="notification_mark_as_read_link">
              <a href="#">Mark as read?</a>
            </div>
          </div>
          <div class="div_aline_right flex_display notification_center_filter_right">
            <div class="notification_center_show_unread flex_display">
              <div class="notification_center_show_unread_label">Unread only</div>
              <div class="notification_center_show_unread_checkbox flex_display"><input type="checkbox" class="flex_display_centered_child"></div>
            </div>

            <div class="notification_center_filter_label">
              Default Filter:
            </div>
            <b-dropdown right variant="link" v-bind:text='currentFilter' no-caret class="m-2 bootstrap_button_dropdown bootstrap_notification_filter" toggle-class="arrow_controller">
              <template slot="button-content">
                <div class="flex_display notification_center_filter_button">
                  <div class="notification_center_filter_button_label">
                    {{currentFilter}}
                  </div>
                  <div class="filter_dropdown dropdown_arrow_small div_aline_right"> </div>
                </div>
              </template>
              <b-dropdown-item
                v-for="filterType in filterTypes"
                class="neon_dropdown_item check_icon"
                @click="setCurrentFilter(filterType.type)"
                :key="filterType.id">
                <div class="flex_display">
                  <div class="neon_dropdown_selected">
                    <font-awesome-icon  v-if='filterType.selected' :icon="['fas', 'check']" class="notification_center_title_icon"></font-awesome-icon>
                  </div>
                  {{filterType.type}}
                </div>

              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>

      <div id="notificationContent">
        <div class="notification_content_container">
          <ul class="notification_content_list">
          <li
            v-for="(notification, index) in notifications"
            v-on:click="!notification.isExpand && expandNotification(notification.id, $event)"
            class="notification_content_list_item"
            v-bind:class="{ notification_hover : !notification.isExpand, notification_no_hover: notification.isExpand }"
            v-bind:key="index">
            <div class="notification_cell" v-bind:class="{ notification_unread : notification.unread, notification_read : !notification.unread, }">
              <div class="notification_cell_detail">
                <div
                  class="flex_display notification_cell_header"
                  v-on:click="notification.isExpand && closeNotification(notification.id, $event)"
                  v-bind:class="{ notification_title_hover: notification.isExpand,  notification_title_no_hover: !notification.isExpand }">
                  <div class="div_aline_left flex_display">
                    <div class="notification_cell_icon">
                      <font-awesome-icon :icon="['fas', 'calendar-alt']" />
                    </div>
                    <div class="notification_cell_title">
                      {{notification.title}}
                    </div>
                  </div>
                  <div class="div_aline_right">
                    <div class="notification_cell_actions flex_display">
                      <div class="notification_cell_action">
                        <a class="clickable" v-on:click="changeReadStatus(index)" href="#">{{notification.unread ? 'Mark as read' : 'Mark as unread'}}</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="notification_cell_subject_time_ago">
                  <div class="notification_cell_subject">
                    <a href="#">{{notification.subject}}</a>
                  </div>
                  <timeago :since="notification.date" class="notification_time_ago"></timeago>
                </div>

                <div class="notification_cell_brief">
                  <div v-bind:class="{notification_cell_brief_text_full:notification.isExpand, notification_cell_brief_text:!notification.isExpand}">
                    <span>{{notification.content}}</span>
                  </div>
                </div>

              </div>
            </div>
          </li>
        </ul>
        </div>
      </div>
      <div id="notification_footer">
      </div>
    </div>

  </transition>

</template>

<script>
  import fontawesome from '@fortawesome/fontawesome'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import solid from '@fortawesome/fontawesome-free-solid'
  import Tooltip from 'vue-directive-tooltip'
  import 'vue-directive-tooltip/css/index.css'
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  require('vue2-animate/dist/vue2-animate.min.css')

  fontawesome.library.add(solid)

  const clickoutside = {
    inserted (el, binding, vnode) {
      function documentHandler (e) {
        if (el.contains(e.target)) {
          return false
        }

        if (binding.expression) {
          binding.value()
        }
      }
      el.__vueClickOutside__ = documentHandler
      document.addEventListener('click', documentHandler)
    },
    update () {},
    unbind (el, binding) {
      document.removeEventListener('click', el.__vueClickOutside__)
      delete el.__vueClickOutside__
    }
  }

  export default {
    name: 'notificationCenter',
    data () {
      return {
        active: false,
        filterDropdownActive: false,
        currentFilter: 'All',
        unreadNumber: 9527,
        filterTypes: [
          {
            id: 0,
            type: 'All',
            selected: true,
            isCheckAll: true,
            disabled: false
          },
          {
            id: 1,
            type: 'Activity',
            selected: false,
            isCheckAll: false,
            disabled: false
          },
          {
            id: 2,
            type: 'Duplicate Scan',
            selected: false,
            isCheckAll: false,
            disabled: false
          },
          {
            id: 3,
            type: 'Executive Report',
            selected: false,
            isCheckAll: false,
            disabled: false
          }
        ],
        justCloseNovigation: false,
        notifications: [
          {
            id: 1,
            type: 'system',
            isHighlight: true,
            date: '08/02/2018',
            title: 'What\'s new with NeonCRM',
            subject: '08/03/2018 Release Notes',
            content: 'Fenix Stats Health reduced from 1200 to 1140. Health Regeneration reduced from 2.50 to 2.38. Shields reduced from 800 to 760. Shield Regeneration reduced from 80 to 76.',
            isExpand: false,
            unread: false
          },
          {
            id: 2,
            type: 'activity',
            isHighlight: false,
            date: '13/01/9999',
            title: 'Activity',
            subject: 'North Korea sent a Rocket to lunar',
            content: 'That\'s one small step for man, one giant leap for mankind.',
            isExpand: false,
            unread: false
          },
          {
            id: 4,
            type: 'activity',
            isHighlight: false,
            date: '05/01/2025',
            title: 'Activity',
            subject: 'NeonCRM opens Fire Island division',
            content: 'NeonCRM is the biggest meat factory of the whole universe. Fire Island government built a ice block with 2 kilometer diameter, and give to NeonCRM as a present.',
            isExpand: false,
            unread: false
          },
          {
            id: 5,
            type: 'activity',
            isHighlight: false,
            date: '04/01/1988',
            title: 'Activity',
            subject: 'Portal has bee invented',
            content: 'This is an ProtoMech. The inventor\'s name is Mickey Trump, Who is Donald Trump\'s aunt\'s brother\'s dad\'s daughter\'s whatever\'s friend. Don\' ask me, I don\'t know why his last name is Trump. But wait, this is not important. The portal can transfer an adult from his computer to the toilet. ',
            isExpand: false,
            unread: false
          },
          {
            id: 6,
            type: 'activity',
            isHighlight: false,
            date: '05/30/2018',
            title: 'Activity',
            subject: 'Edward Shen win the Nobel Prize',
            content: 'Edward Shen is the greatest scientist in Azeroth.',
            isExpand: false,
            unread: false
          }
        ]
      }
    },
    components: {
      FontAwesomeIcon,
      Tooltip
    },
    directives: {
      clickoutside
    },
    props: ['panelActive'],
    methods: {
      tohide: function () {
        console.log('click close')
        this.$emit('xoxoxox')
      },
      closeFilterDropdown: function () {
        this.filterDropdownActive = false
      },
      toggleFilterDropdown: function () {
        this.filterDropdownActive = !this.filterDropdownActive
      },
      setCurrentFilter: function (value) {
        var displayString = ''
        for (var index in this.filterTypes) {
          if (value === this.filterTypes[index].type) {
            this.filterTypes[index].selected = !this.filterTypes[index].selected
          } else {
            this.filterTypes[index].selected = false
          }

          if (this.filterTypes[index].selected) {
            if (displayString !== '') {
              displayString += ', '
            }

            displayString += this.filterTypes[index].type
          }
        }

        this.currentFilter = displayString
      },
      expandNotification: function (notificationId, e) {
        if (e.target.classList.contains('notification_title_hover')) {
          return false
        }
        if (e.target.classList.contains('clickable')) {
          return false
        }

        for (var index in this.notifications) {
          if (this.notifications[index].id === notificationId) {
            this.notifications[index].isExpand = true
            this.notifications[index].unread = false
          } else {
            this.notifications[index].isExpand = false
          }
        }
        e.preventDefault()
      },
      closeNotification: function (notificationId, e) {
        if (e.target.classList.contains('clickable')) {
          return false
        }
        for (var index in this.notifications) {
          if (this.notifications[index].id === notificationId) {
            this.notifications[index].isExpand = false
          } else {
            this.notifications[index].isExpand = false
          }
        }
        e.preventDefault()
      },
      changeReadStatus: function (index) {
        this.notifications[index].unread = !this.notifications[index].unread
      },
      showSplash () {
        this.$modal.show('splash')
      },
      hideSplash () {
        this.$modal.hide('splash')
      },
      handleTopScroll () {
        document.getElementById('notificationCenter').style.top = window.scrollY + 'px'
      },
      load: function () {
        console.log('loaded')
      }
    },
    mounted: function () {
      window.addEventListener('scroll', this.handleTopScroll)
    },
    destroy: function () {
      window.removeEventListener('scroll', this.handleResize)
    },
    watch: {
      panelActive: function () {
        if (this.panelActive) {
          this.handleTopScroll()
        }
      }
    }
  }
</script>

<style scoped>
  @media only screen and (max-width: 600px) {
    #notificationCenter {
      position: absolute;
      height: 100%;
      width: 100%;
      z-index: 10;
      background-color: #fff;
      right: 0px;
      top: 0px;
      box-shadow: 0 0 16px 0 rgba(0,0,0,0.24);
      display: flex;
      flex-direction: column;
    }
  }

  @media only screen and (min-width: 601px) {
    #notificationCenter {
      position: absolute;
      height: 100%;
      width: 600px;
      z-index: 10;
      background-color: #fff;
      right: 0px;
      top: 0px;
      box-shadow: 0 0 16px 0 rgba(0,0,0,0.24);
      display: flex;
      flex-direction: column;
    }
  }

  .notification_banner {
    height: 78px;
    color: #fff;
    background-color: #0074D9;
    width: 100%;
  }

  .notification_center_title {
    padding-left: 30px;
    line-height: 78px;
    height: 78px;
    font-size: 20px;
  }

  .notification_center_header_right {
    margin-top: 5px;
    margin-right: 10px;
  }

  .notification_center_title_icon {
    margin-right: 10px;
  }

  #notification_filter {
    height: 45px;
    background-color: #D8DDE6;
    width: 100%;
    top: 78px;
  }

  .notification_center_filter_button {
    position: relative;
    font-size: 12px;
    padding: 1px 3px;
  }

  .notification_center_filter_right {
    float: right;
    height: 45px;
    line-height: 45px;
    padding-right: 20px;
  }

  .notification_center_filter_label {
    white-space: nowrap;
    font-size: 12px;
  }

  .navigation_dropdown.notification_center_filter_list {
    top: 33px;
  }

  #notificationContent {
    flex: 1;
    display: flex;
    min-height: 0px;
    flex-direction: column;
  }

  .notification_content_container {
    overflow: auto;
    flex: 1;
  }

  .notification_content_list {
    list-style: none;
    padding: 0px;
    overflow: hidden;
  }

  .notification_cell_header {
    font-size: 12px;
    color: #002D41;
    line-height: 15px;
    margin-bottom: 3px;
    padding: 3px;
  }

  .notification_cell_brief {
    font-size: 14px;
    color: #002D41;
  }

  .notification_content_list_item {
    border-bottom: 1px solid #ddd;
    padding: 0;
  }

  .notification_content_list_item.topped {
    background: #D5EAFE;
    box-shadow: inset 0 1px 3px 0 rgba(0,0,0,0.50);
  }

  .topped .notification_cell_dot {
    visibility: hidden;
  }

  .notification_cell_dot {
    font-size: 20px;
  }

  .notification_cell_subject_time_ago {
    font-size: 16px;
    color: #002D41;
    height: 19px;
    line-height: 19px;
    margin-bottom: 3px;
    display: flex;
  }

  @media only screen and (max-width: 600px) {
    .notification_cell {
      display: flex;
      padding: 5px 10px;
    }

    .notification_cell_brief_text {
      width: 80%;
    }

    .notification_cell_detail {
      width: 100%;
    }

    .notification_cell_dot {
      width: 10%;
    }

    .notification_cell_brief.flex_display {
      display: block;
    }

    .notification_cell_action_group {
      display: block;
    }

    .notification_cell_brief {
      height: auto;
    }

    .notification_cell_brief_text {
      height: 17px;
      line-height: 17px;
    }

    .notification_cell_brief_text_full {
      height: auto;
      line-height: 17px;
    }

    .notification_cell_subject {
      max-width: 60%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .notification_unread_message_container {
      line-height: 22px;
      font-size: 12px;
    }

    .notification_unread_message {
      padding-left: 15px;
    }
  }

  @media only screen and (min-width: 601px) {
    .notification_cell {
      display: flex;
      padding: 17px 30px;
    }

    .notification_cell_brief_text {
      width: 500px;
    }

    .notification_cell_detail {
      width: 100%;
    }

    .notification_cell_dot {
      width: 50px;
      font-size: 20px;
    }

    .notification_cell_action_group {
      width: 200px;
      display: none;
      font-size: 12px;
    }

    .notification_cell:hover .notification_cell_brief_text {

    }

    .notification_cell:hover .notification_cell_action_group {
      display: block;
    }

    .notification_cell_brief_text {
      height: 17px;
      line-height: 17px;
    }

    .notification_cell_brief_text_full {
      height: auto;
      line-height: 17px;
    }

    .notification_cell_subject {
      max-width: 300px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .notification_unread_message_container {
      line-height: 45px;
      font-size: 12px;
      display: flex;
    }

    .notification_unread_message {
      padding-left: 30px;
    }
  }

  .notification_time_ago {
    margin-bottom: auto;
    flex-grow: 1;
    line-height: 12px;
    margin-top: 7px;
    font-size: 12px;
    margin-left: 10px;
  }

  .notification_cell_brief_text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .notification_cell_brief_text_full {
    text-overflow: ellipsis;
  }

  .notification_cell_action {
    color: #0074d9;
    margin-left: 5px;
    font-weight: 400;
  }

  .notification_cell_action.first_link {
    margin-left: 0px;
  }

  .filter_dropdown {
    top: 7px;
    margin-left: 5px;
    height: 18px;
    line-height: 18px;
  }

  .notification_hover {
    cursor: pointer;
  }

  .notification_hover:hover {
    background-color: #f2f2f2;
  }

  .notification_title_hover {
    cursor: pointer;
    background-color: #f2f2f2;
  }

  .notification_title_hover:hover {
    cursor: pointer;
    background-color: #ddd;
  }

  .notification_cell_detail {
    border: 3px solid transparent;
  }

  .notification_no_hover .notification_cell_detail {
    border: 3px solid #f2f2f2;
  }

  notification_no_hover {
     background-color: #fff
   }

  .notification_title_no_hover {
  }

  .notification_cell_actions {
    float: right;
    font-size: 12px;
  }

  .splash_information_container {
    padding: 15px 30px;
  }

  .splash_information_date {
    font-size: 12px;
    color: #002D41;
  }

  .splash_information_wutsnew {
    font-size: 16px;
    color: #002D41;
    font-weight: 700;
  }

  .splash_information_wutsnew_container {
    margin-right: auto;
  }

  .notification_mark_as_read_link {
    padding-left: 15px;
    font-weight: 400;
  }

  .notification_cell_title {
    margin-left: 10px;
  }

  .notification_cell_date {
    margin-left: 10px;
  }

  .notification_unread {
    font-weight: 700;
  }

  .notification_unread .notification_cell_icon {
    color: #00b300;
  }

  .bootstrap_notification_filter {
    width: 30px;
  }

  .notification_center_show_unread {
    font-size: 12px;
  }

  .notification_center_show_unread_label {
    margin-right: 10px;
  }

  .notification_center_show_unread {
    margin-right: 10px;
  }
</style>

<style>

  .v--modal-overlay .v--modal-box.splash_modal {
    overflow-Y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/NotificationCenter.vue